// Babel Dependencies
// If using es6 you might need for browser compatablity.
// This includes core-js but makes bloats the JS considerably. Use only if needed.
// import "babel-polyfill";

// Scripts
import "./fixed-header";
import "./touch-menu";
//import "./style-helper";
import "./dropdown-menu";
import "./faq-item";
import "./gallery-section";

import "./header-transition";

import "./color-visualizer";

import "./panel-photo-gallery";

import "./estimate-form";